import React, { useEffect, useState } from 'react'
import { NavBar, Toast } from 'antd-mobile'
import axios from 'axios';
import API_ROUTES from '../api';
import GameListContainer from './GameListContainer/index';

export default function Applicate() {

  const [gameList, setGameList] = useState([])


  const getGameInfo = () => {
    Toast.show({
      icon: 'loading'
    });
    axios.get(API_ROUTES.game_list, {
      params: {
        count: -1,
        status: 0
      }
    })
      .then(function (response) {
        const data = response?.data?.data || [];
        setGameList(data);
      })
      .catch(function (error) {
        console.error('Error fetching game list:', error);
        Toast.show({
          icon: 'fail',
          content: '加载失败'
        });
      })
      .finally(() => {
        Toast.clear()
      });
  }

  useEffect(() => {
    getGameInfo()
  }, []);


  return (
    <div className="applicate-container has-unified-nav ui-page ui-page--with-nav">
      <NavBar
        className="unified-navbar fixed"
        onBack={() => window.history.back()}
      >
        比赛列表
      </NavBar>
      <div className='body_detail ui-page__content'>
        <GameListContainer gameList={gameList} />
      </div>
    </div>
  )

}
